export function EyebrowLabel({ children, className = '' }) {
  return (
    <p
      className={`text-[12px] font-extrabold uppercase tracking-[0.2em] text-teal-700 ${className}`}
    >
      {children}
    </p>
  )
}
